export const cardV2 = '2';
